module.exports = __webpack_public_path__ + "static/media/55.46a53044.mp4";